import axios from 'axios';

// 创建 axios 实例
const service = axios.create({
  baseURL: 'https://data-back.wedoing.club',
  timeout: 500000, // 超时时间
});

// 简单封装 GET 请求
export const get = (url, params) => {
  return service.get(url, { params });
};

// 简单封装 POST 请求
export const post = (url, data) => {
  return service.post(url, data);
};

// 统一导出
export default {
  get,
  post,
};
